import { i18n } from '@/i18n'
import { ActivityLogParser } from '@/parsers/activityLog'
import { ContactType } from '@/enums/graphql'
import { kebabCase } from 'lodash'
import DOMPurify from 'dompurify'

export class ContactRelationshipActivityLogParser extends ActivityLogParser {
    static getContactRelationShipInfo (relationship) {
        const node1 = {
            'type': kebabCase(relationship?.definition?.node1_type),
            'name': relationship?.node1?.type === ContactType.PERSON ? `${relationship?.node1.first_name} ${relationship?.node1.last_name}` : relationship?.node1?.type === ContactType.COMPANY ? relationship?.node1?.company_name : '',
        }
        const node2 = {
            'type': kebabCase(relationship?.definition?.node2_type),
            'name': relationship?.node2?.type === ContactType.PERSON ? `${relationship?.node2.first_name} ${relationship?.node2.last_name}` : relationship?.node2?.type === ContactType.COMPANY ? relationship?.node2?.company_name : '',
        }

        const nodeNames = []
        if (node1.name) { nodeNames.push(node1.name) }
        if (node2.name) { nodeNames.push(node2.name) }

        const relationshipInfo = {
            'type': node1.type && node2.type ? `${i18n.tc(`common.contact.relationship.node-type-neutral.${node1.type}`, 1)}–${i18n.tc(`common.contact.relationship.node-type-neutral.${node2.type}`, 1)}` : '',
            'nodes': nodeNames.length > 1 ? nodeNames.join(' / ') : '', // Nodes only provide a useful info if there are at least 2 of them.
        }

        return relationshipInfo
    }

    static getLogDescriptionCreated (activityLog, data) {
        const relationshipInfo = this.getContactRelationShipInfo(activityLog.subject)

        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc(`common.change-log.subject.some--target.${kebabCase(activityLog.log_name)}${relationshipInfo.type ? '--with-type' : ''}`, 1, { relationshipType: relationshipInfo.type })}</b>${relationshipInfo.nodes ? ` (${relationshipInfo.nodes})` : ''}`,
        }
        if (data.causer) {
            return i18n.t('common.change-log.someone-added-something', interpolationParams)
        } else {
            return i18n.tc('common.change-log.something-has-been-added', 1, interpolationParams)
        }
    }

    static getLogDescriptionUpdated (activityLog, data) {
        const relationshipInfo = this.getContactRelationShipInfo(activityLog.subject)

        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc(`common.change-log.subject.some--target.${kebabCase(activityLog.log_name)}${relationshipInfo.type ? '--with-type' : ''}`, 1, { relationshipType: relationshipInfo.type })}</b>${relationshipInfo.nodes ? ` (${relationshipInfo.nodes})` : ''}`,
        }
        if (data.causer) {
            return i18n.t('common.change-log.someone-updated-something', interpolationParams)
        } else {
            return i18n.tc('common.change-log.something-has-been-updated', 1, interpolationParams)
        }
    }

    static getLogDescriptionDeleted (activityLog, data) {
        const nodeTypes = activityLog.properties?.old?.['definition.type'].split('__')
        const relationshipType = `${i18n.tc(`common.contact.relationship.node-type-neutral.${kebabCase(nodeTypes[0])}`, 1)}–${i18n.tc(`common.contact.relationship.node-type-neutral.${kebabCase(nodeTypes[1])}`, 1)}`

        const interpolationParams = {
            someone: data.causer,
            something: `<b>${i18n.tc(`common.change-log.subject.some--target.${kebabCase(activityLog.log_name)}${nodeTypes.length ? '--with-type' : ''}`, 1, { relationshipType: relationshipType })}</b>`,
        }
        if (data.causer) {
            return i18n.t('common.change-log.someone-deleted-something', interpolationParams)
        } else {
            return i18n.tc('common.change-log.something-has-been-deleted', 1, interpolationParams)
        }
    }
}
